export default "__VITE_ASSET__qfcHgVAB__"